import React, { useEffect, useState } from "react";
import styles from "./DashboardLoader.module.scss";
import MeritoButton from "../../../../../components/common/MeritoButtons/MeritoButtons";
import { HiChevronRight } from "react-icons/hi";
import { AgJobsStatus } from "../AgencyDashboardTabs";
import { useSelector } from "react-redux";

const messages = [
  "Setting up your dashboard...",
  "Getting sales from all brands...",
  "Loading ad budgets...",
  "Calculating your targets...",
  "Almost there...",
];

const ProgressWithMessages: React.FC = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const [completed, setCompleted] = useState(false);
  const status = useSelector((s: any) => s.agencyDashboard.status);
  console.log("Status in loader: ", status);
  // const status = AgJobsStatus.technicalError;

  useEffect(() => {
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          setCompleted(true);
          return 100;
        }
        return prev + 100 / (15 * 10);
      });
    }, 100);

    const messageInterval = setInterval(() => {
      setCurrentMessageIndex((prev) =>
        prev === messages.length - 1 ? prev : prev + 1
      );
    }, 3000);

    return () => {
      clearInterval(progressInterval);
      clearInterval(messageInterval);
    };
  }, []);

  if (completed || status === AgJobsStatus.technicalError) {
    return (
      <div className={styles.timeoutContainer}>
        <h2 className={styles.timeoutTitle}>
          {status === AgJobsStatus.technicalError
            ? "Technical Error!"
            : "Taking longer than usual!"}
        </h2>
        <p className={styles.timeoutSubtitle}>
          {status === AgJobsStatus.technicalError
            ? "There seems to be an error with Merito."
            : "Try again in 30 minutes or contact us."}
        </p>
        <div>
          <MeritoButton
            type="primary-1"
            children={
              <span>
                Contact Us <HiChevronRight />{" "}
              </span>
            }
            size="lg"
            hover={false}
            onClick={() => {
              window.open("https://wa.me/+919892941618", "_blank");
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.progressContainer}>
      <p className={styles.message}>{messages[currentMessageIndex]}</p>
      <div className={styles.progressBar}>
        <div
          className={styles.progressFill}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressWithMessages;
